const isSafari = () =>
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

const isJsons = (array) =>
  Array.isArray(array) &&
  array.every((row) => typeof row === 'object' && !(row instanceof Array))

const isArrays = (array) =>
  Array.isArray(array) && array.every((row) => Array.isArray(row))

const jsonsHeaders = (array) =>
  Array.from(
    array
      .map((json) => Object.keys(json))
      .reduce((a, b) => new Set([...a, ...b]), []),
  )

const jsons2arrays = (jsons, headers) => {
  headers = headers || jsonsHeaders(jsons)

  let headerLabels = headers
  let headerKeys = headers
  if (isJsons(headers)) {
    headerLabels = headers.map((header) => header.label)
    headerKeys = headers.map((header) => header.key)
  }

  const data = jsons.map((object) =>
    headerKeys.map((header) => getHeaderValue(header, object)),
  )
  return [headerLabels, ...data]
}

const getHeaderValue = (property, obj) => {
  const foundValue = property
    .replace(/\[([^\]]+)]/g, '.$1')
    .split('.')
    .reduce(function (o, p, i, arr) {
      if (o[p] === undefined) {
        return arr.slice(1)
      } else {
        return o[p]
      }
    }, obj)

  return foundValue === undefined ? '' : foundValue
}

const elementOrEmpty = (element) => (element || element === 0 ? element : '')

const joiner = (data, separator = ',', enclosingCharacter = '"') => {
  return data
    .filter((e) => e)
    .map((row) =>
      row
        .map((element) => elementOrEmpty(element))
        .map((column) => `${enclosingCharacter}${column}${enclosingCharacter}`)
        .join(separator),
    )
    .join(`\n`)
}

const arrays2csv = (data, headers, separator, enclosingCharacter) =>
  joiner(headers ? [headers, ...data] : data, separator, enclosingCharacter)

const jsons2csv = (data, headers, separator, enclosingCharacter) =>
  joiner(jsons2arrays(data, headers), separator, enclosingCharacter)

const string2csv = (data, headers, separator, enclosingCharacter) =>
  headers ? `${headers.join(separator)}\n${data}` : data

const toCSV = (data, headers, separator, enclosingCharacter) => {
  if (isJsons(data))
    return jsons2csv(data, headers, separator, enclosingCharacter)
  if (isArrays(data))
    return arrays2csv(data, headers, separator, enclosingCharacter)
  if (typeof data === 'string') return string2csv(data, headers, separator)
  throw new TypeError(
    `Data should be a "String", "Array of arrays" OR "Array of objects" `,
  )
}

const buildURI = (data, uFEFF, headers, separator, enclosingCharacter) => {
  const csv = toCSV(data, headers, separator, enclosingCharacter)
  const type = isSafari() ? 'application/csv' : 'text/csv'
  const blob = new Blob([uFEFF ? '\uFEFF' : '', csv], { type })
  const dataURI = `data:${type};charset=utf-8,${uFEFF ? '\uFEFF' : ''}${csv}`

  const URL = window.URL || window.webkitURL

  return typeof URL.createObjectURL === 'undefined'
    ? dataURI
    : URL.createObjectURL(blob)
}

function saveFile(blobURL, filename) {
  const a = document.createElement('a')
  document.body.appendChild(a)
  a.href = blobURL
  a.download = filename
  a.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(blobURL)
    document.body.removeChild(a)
  }, 0)
}

export function exportCsv(props) {
  const { headerCVS, dataCSV, fileName } = props
  const blobURL = buildURI(dataCSV, undefined, headerCVS)
  saveFile(blobURL, fileName + '.csv')
}
